import { Stack, Grid } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import { FormattedScheduleListItem } from '@occc-app/lib/util-location-schedule';

type LocationScheduleCardProps = {
  schedule: FormattedScheduleListItem[];
};

export const LocationScheduleCard = (props: LocationScheduleCardProps) => {
  const { schedule } = props;

  const renderedWorkingHours = schedule.map(({ period, timeSchedule }) => (
    <Stack
      key={`${period}_${timeSchedule}`}
      direction='row'
      alignItems='center'
      justifyContent='space-between'
    >
      <Typography>{period}</Typography>
      <Typography>{timeSchedule}</Typography>
    </Stack>
  ));

  return (
    <Grid item xs={12} md={4}>
      <Typography variant='body2' color='textSecondary' gutterBottom>
        Working Hours
      </Typography>
      <Stack>{renderedWorkingHours}</Stack>
    </Grid>
  );
};
